import { render, staticRenderFns } from "./PassengerStepComponent.vue?vue&type=template&id=2f80faac&scoped=true"
import script from "./PassengerStepComponent.vue?vue&type=script&lang=js"
export * from "./PassengerStepComponent.vue?vue&type=script&lang=js"
import style0 from "./PassengerStepComponent.vue?vue&type=style&index=0&id=2f80faac&prod&lang=scss&scoped=true"
import style1 from "./PassengerStepComponent.vue?vue&type=style&index=1&id=2f80faac&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f80faac",
  null
  
)

export default component.exports